"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlaceStruct = exports.DisplayConfig = exports.SocialLinksDataStruct = exports.CounterNameStruct = exports.ServiceCategoryStruct = exports.PlaceContactDataStruct = exports.PlaceSettingsStruct = exports.MessagingConfigStruct = exports.ContactDataConfigStruct = exports.DisplayLayoutStruct = exports.DISPLAY_LAYOUT = exports.DISPLAY_MAIN_FIELD = void 0;
const superstruct_1 = require("superstruct");
const locale_1 = require("./locale");
const openingHours_1 = require("./openingHours");
const customisation_1 = require("./customisation");
exports.DISPLAY_MAIN_FIELD = {
    ticketNumber: '__ticket_number',
    contactFullName: '__contact_fullName',
    contactFirstName: '__contact_firstName',
    contactLastName: '__contact_lastName',
    contactEmail: '__contact_email',
    contactPhone: '__contact_phone',
    contactNumberOfVisitors: '__contact_numberOfVisitors',
};
exports.DISPLAY_LAYOUT = {
    classicFullscreenV1: 'classic-fullscreen-v1',
};
exports.DisplayLayoutStruct = (0, superstruct_1.enums)([exports.DISPLAY_LAYOUT.classicFullscreenV1]);
exports.ContactDataConfigStruct = (0, superstruct_1.type)({
    askEmail: (0, superstruct_1.defaulted)((0, superstruct_1.optional)((0, superstruct_1.boolean)()), false),
    askPhone: (0, superstruct_1.defaulted)((0, superstruct_1.optional)((0, superstruct_1.boolean)()), false),
    askName: (0, superstruct_1.defaulted)((0, superstruct_1.optional)((0, superstruct_1.boolean)()), false),
    askNumberOfVisitors: (0, superstruct_1.defaulted)((0, superstruct_1.optional)((0, superstruct_1.boolean)()), false),
    emailOptionalInBooking: (0, superstruct_1.defaulted)((0, superstruct_1.optional)((0, superstruct_1.boolean)()), false),
    emailOptionalInKiosk: (0, superstruct_1.defaulted)((0, superstruct_1.optional)((0, superstruct_1.boolean)()), false),
    phoneOptionalInBooking: (0, superstruct_1.defaulted)((0, superstruct_1.optional)((0, superstruct_1.boolean)()), false),
    phoneOptionalInKiosk: (0, superstruct_1.defaulted)((0, superstruct_1.optional)((0, superstruct_1.boolean)()), false),
    nameOptionalInBooking: (0, superstruct_1.defaulted)((0, superstruct_1.optional)((0, superstruct_1.boolean)()), false),
    nameOptionalInKiosk: (0, superstruct_1.defaulted)((0, superstruct_1.optional)((0, superstruct_1.boolean)()), false),
    numberOfVisitorsOptionalInBooking: (0, superstruct_1.defaulted)((0, superstruct_1.optional)((0, superstruct_1.boolean)()), false),
    numberOfVisitorsOptionalInKiosk: (0, superstruct_1.defaulted)((0, superstruct_1.optional)((0, superstruct_1.boolean)()), false),
});
exports.MessagingConfigStruct = (0, superstruct_1.type)({
    useUIMessenger: (0, superstruct_1.defaulted)((0, superstruct_1.optional)((0, superstruct_1.boolean)()), true),
    useMailMessenger: (0, superstruct_1.defaulted)((0, superstruct_1.optional)((0, superstruct_1.boolean)()), true),
    useWebPushMessenger: (0, superstruct_1.defaulted)((0, superstruct_1.optional)((0, superstruct_1.boolean)()), true),
    useSMSMessenger: (0, superstruct_1.defaulted)((0, superstruct_1.optional)((0, superstruct_1.boolean)()), false),
    useWhatsAppMessenger: (0, superstruct_1.defaulted)((0, superstruct_1.optional)((0, superstruct_1.boolean)()), false),
    useBulkgateMessenger: (0, superstruct_1.defaulted)((0, superstruct_1.optional)((0, superstruct_1.boolean)()), false),
});
exports.PlaceSettingsStruct = (0, superstruct_1.type)({
    appointmentsPerUser: (0, superstruct_1.optional)((0, superstruct_1.enums)(['one-per-service', 'one-per-place', 'unlimited'])),
    visitorChatEnabled: (0, superstruct_1.defaulted)((0, superstruct_1.optional)((0, superstruct_1.boolean)()), false),
    chatNotificationCooldownMinutes: (0, superstruct_1.defaulted)((0, superstruct_1.optional)((0, superstruct_1.number)()), 30), // min minutes between chat notifications to visitor
});
exports.PlaceContactDataStruct = (0, superstruct_1.type)({
    phoneNumber: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    email: (0, superstruct_1.optional)((0, superstruct_1.string)()),
});
exports.ServiceCategoryStruct = (0, superstruct_1.type)({
    id: (0, superstruct_1.string)(),
    name: (0, superstruct_1.string)(),
});
exports.CounterNameStruct = (0, superstruct_1.type)({
    id: (0, superstruct_1.string)(),
    name: (0, superstruct_1.string)(),
});
exports.SocialLinksDataStruct = (0, superstruct_1.type)({
    facebook: (0, superstruct_1.string)(),
    linkedin: (0, superstruct_1.string)(),
    twitter: (0, superstruct_1.string)(),
    instagram: (0, superstruct_1.string)(),
});
exports.DisplayConfig = (0, superstruct_1.type)({
    publicFormFieldIds: (0, superstruct_1.optional)((0, superstruct_1.defaulted)((0, superstruct_1.array)((0, superstruct_1.string)()), [])),
    layout: (0, superstruct_1.optional)((0, superstruct_1.defaulted)(exports.DisplayLayoutStruct, exports.DISPLAY_LAYOUT.classicFullscreenV1)),
    locale: (0, superstruct_1.optional)(locale_1.LocaleLongStruct),
    isDisplayService: (0, superstruct_1.optional)((0, superstruct_1.defaulted)((0, superstruct_1.boolean)(), false)),
    mainDisplayField: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    hideQRCode: (0, superstruct_1.optional)((0, superstruct_1.defaulted)((0, superstruct_1.boolean)(), false)),
    customText: (0, superstruct_1.optional)((0, superstruct_1.string)()),
});
exports.PlaceStruct = (0, superstruct_1.type)({
    id: (0, superstruct_1.string)(),
    name: (0, superstruct_1.string)(),
    userId: (0, superstruct_1.string)(),
    organisationId: (0, superstruct_1.string)(),
    subscriptionId: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    description: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    address: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    logo: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    timezone: (0, superstruct_1.defaulted)((0, superstruct_1.string)(), 'Europe/Berlin'),
    contactData: (0, superstruct_1.defaulted)((0, superstruct_1.optional)(exports.PlaceContactDataStruct), {}),
    messagingConfig: exports.MessagingConfigStruct,
    contactDataConfig: (0, superstruct_1.defaulted)(exports.ContactDataConfigStruct, {}),
    settings: (0, superstruct_1.defaulted)(exports.PlaceSettingsStruct, {}),
    openingHours: (0, superstruct_1.defaulted)(openingHours_1.OpeningHoursStruct, {}),
    serviceCategories: (0, superstruct_1.defaulted)((0, superstruct_1.array)(exports.ServiceCategoryStruct), []),
    locale: (0, superstruct_1.defaulted)((0, superstruct_1.optional)(locale_1.LocaleLongStruct), locale_1.DefaultLocaleLong),
    socials: (0, superstruct_1.optional)(exports.SocialLinksDataStruct),
    translations: (0, superstruct_1.optional)((0, superstruct_1.record)((0, superstruct_1.string)(), (0, superstruct_1.string)())),
    customisation: (0, superstruct_1.defaulted)(customisation_1.CustomisationDataStruct, customisation_1.LightTheme),
    displayConfig: (0, superstruct_1.optional)(exports.DisplayConfig), // fields that are public and should be copied to tickets_short
});
exports.PlaceStruct.type = 'Place';
exports.MessagingConfigStruct.type = 'MessagingConfig';
exports.PlaceSettingsStruct.type = 'PlaceSettings';
exports.PlaceContactDataStruct.type = 'PlaceContactData';
exports.ServiceCategoryStruct.type = 'ServiceCategory';
exports.ContactDataConfigStruct.type = 'ContactDataConfig';
//# sourceMappingURL=place.js.map